import React, { useState, useCallback } from 'react';
import Dropdown from '../../Components/Dropdown/Dropdown';
import Stepper from '../../Components/Stepper/Stepper';
import { Button, Input, Textarea } from '../../Components/StyledComponents';
import { convertCost, onlyNum } from '../../Utils/functions';
import './CommerceCouponCreate.scss';
import axios from 'axios';
import { alertRef } from '../../App';
import Modal from '../../Components/Modal/Modal';
import CommerceCouponImage from './CommerceCouponImage';
import ReactDragListView from 'react-drag-listview';
import RadioButtonGroup from '../../Components/RadioButtonGroup/RadioButtonGroup';

const CommerceCouponCreate = ({ createCoupon }) => {
    const [ step, setStep ] = useState(1);//입력 단계
    const [ name, setName ] = useState('')//쿠폰 이름
    const [ type, setType ] = useState('카페')//쿠폰 타입
    const [ price, setPrice ] = useState(1000);//쿠폰 가격
    const [ discountRate, setDiscountRate ] = useState(10)//할인율
    const [ desc, setDesc ] = useState('')//쿠폰 설명
    const [images, setImages] = useState([])//쿠폰 이미지
    const [ isLimit, setIsLimit ] = useState('false')//판매 수량 제한 여부
    const [ count, setCount ] = useState('')//제한 수량

    const imageModalRef = React.useRef(null)//이미지 추가 모달

    //쿠폰 생성
    const create = () => {
        createCoupon(name,desc,discountRate,price,type,images,isLimit,count)
    }

    //이미지 추가
    const addImage = (fileName) => {
        imageModalRef.current.closeModal()
        setImages(old => [...old,fileName])
    }

    //step 이동
    const goNext = () => {
        if(step === 3){
            create()
        }else if( step === 2){
            alertRef.current.showAlert({ title : `커머스 쿠폰을 발행하시겠어요?`, subWarnTitle : '쿠폰은 본사에서 검수 후 판매가 시작됩니다.', isConfirm : true, confirmText : '발행', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();create()} })
        }else {
            setStep(old => old + 1)
        }
    }

    //next disalbe check
    const getDisabled = () => {
        if(step === 1){
            if( name.trim() === '' || price === 0 || price === '' || discountRate.length === 0 || desc.trim() === '' ) return true
            else return false
        }else if(step === 2){
            if( images.length === 0 )return true
            else return false
        }else {
            return false
        }
    }

    //할인율 handler
    const handleDiscountRate = (val) => {
        if(val >= 100) setDiscountRate(100)
        else setDiscountRate(val)
    }

    const dragProps = {
        onDragEnd(fromIndex, toIndex) {
          const data = [...images];
          const item = data.splice(fromIndex, 1)[0];
          data.splice(toIndex, 0, item);
          setImages([...data]);
        },
        nodeSelector: 'div',
        handleSelector: 'div',
        lineClassName : 'line',
    };
    
    //판매수량 handler
    const handleCount = () => {
        if(Number(count) > 1000) setCount(1000)
        else if(Number(count) <= 0) setCount(1)
    }

    //가격 handler
    const handlePrice = () => {
        if(Number(price) < 1000) setPrice(1000)
    }
    
    return (
        <div className='commerce-coupon-create'>
            <Stepper maxStep={2} step={step} containerStyle={{ marginBottom : 40 }}/>
            {
                step === 1 &&
                <div>
                    <div className='row'>
                        <p className='input-label'>수량 제한</p>
                        <RadioButtonGroup
                            value={isLimit}
                            checked={isLimit}
                            onChange={(val) => setIsLimit(val)}
                            options={[
                                { value : 'false', label : '제한없음'},
                                { value : 'true', label : '제한'},
                            ]}
                            perRows={2}
                            small
                            containerStyle={{ width : '50%', marginLeft : 24}}
                            id="limit"
                        />
                    </div>
                    {
                        isLimit === 'true' &&
                        <div className='row between'>
                            <p className='input-label'>판매수량</p>
                            <Input
                                value={count}
                                onChange={(e) => setCount(onlyNum(e.target.value))}
                                onBlur={(e) => handleCount(e.target.value)}
                                placeholder='판매 수량을 입력해주세요.'
                                style={{ width : 347 }}
                                max={1000}
                            />
                        </div>
                    }
                    
                     <div className='row between'>
                        <p className='input-label'>상품명</p>
                        <Input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder='상품명을 입력해주세요.'
                            style={{ width : 347 }}
                        />
                    </div>

                    <div className='row between'>
                        <p className='input-label'>상품 정가</p>
                        <Input
                            value={price}
                            onChange={(e) => setPrice(onlyNum(e.target.value))}
                            placeholder='상품 정가를 입력해주세요.'
                            style={{ width : 347 }}
                            onBlur={() => handlePrice()}
                        />
                    </div>

                    <div className='row between'>
                        <p className='input-label'>할인율(%)</p>
                        <Input
                            value={discountRate}
                            onChange={(e) => handleDiscountRate(onlyNum(e.target.value))}
                            placeholder='쿠폰명을 입력해주세요.'
                            style={{ width : 347 }}
                            max={100}
                        />
                    </div>
                    
                    <div className='row between'>
                        <p className='input-label'>판매가</p>
                        <Input
                            value={convertCost(parseInt(price - (price * discountRate / 100))) + '원'}
                            disabled
                            style={{ width : 347, color : '#f95f53' }}
                        />
                    </div>
                    <p className='warn-text'>* 실제 소비자에게 판매되는 가격입니다.</p>
                    <div className='row between'>
                        <p className='input-label'>카테고리</p>
                        <Dropdown
                            key={'coupon-type'}
                            options={[
                                { key : '카페', value : '카페'},
                                { key : '베이커리', value : '베이커리'},
                                { key : '버거/피자', value : '버거/피자'},
                                { key : '치킨', value : '치킨'},
                                { key : '음식', value : '음식'},
                                { key : '뷰티/헤어', value : '뷰티/헤어'},
                                { key : '문구/소품', value : '문구/소품'},
                                { key : '생활/가전', value : '생활/가전'},
                                { key : '도서', value : '도서'},
                                { key : '반려동물', value : '반려동물'},
                            ]}
                            width={347}
                            value={type}
                            onItemClick={(val) => setType(val)}
                        />
                    </div>
                    <div className='row between' style={{ alignItems : 'flex-start'}}>
                        <p className='input-label'>쿠폰설명</p>
                        <Textarea
                            value={desc}
                            onChange={(e) => setDesc(e.target.value)}
                            placeholder='쿠폰 설명을 입력해주세요.'
                            style={{ width : 347, height : 173 }}
                        />
                    </div>
                </div>
            }

            {
                step === 2 &&
                <div>
                    <p className='label' style={{ width : 'fit-content'}}>쿠폰 이미지를 등록해보세요.</p>  
                    <p className='img-warn-text' style={{ textAlign : 'left'}}>* 발행하기 버튼을 누르시면 본사에서 검수 후 판매가 시작 되니 다시 한번 확인해 주세요.</p>              

                    <div className='file-btn' style={{ cursor : 'pointer' }}>
                        <div className='row' style={{ marginBottom : 0}} onClick={() => imageModalRef.current.openModal()}>
                            <img src={require('../../aseets/icons/plus_pink.svg').default} style={{ width : 24, height : 24, marginRight : 8 }} />
                            이미지 추가하기
                        </div>
                    </div>

                    <ReactDragListView {...dragProps}>
                    {
                        images.map((data,i) => {
                            return (
                                <div className='row image-row'>
                                    <img src={"https://cdn.syrupfriends.com/Images/Commerce/" + data} className='coupon-img'/>
                                    <p className='move-icon' style={{ width : 64, transition : 'all', transitionDuration : '0.2s' }}>
                                        <img src={require('../../aseets/icons/menu-drag.svg').default} style={{ width : 24, height : 24, pointerEvents : 'none' }} />
                                    </p>
                                </div>
                            )
                        })
                    }
                    </ReactDragListView>
                </div>
            }
            
            <div className='btn-row'>
                {
                    step === 2 &&
                    <Button
                        variant="outline"
                        fontSize={16}
                        style={{ width : 118, marginRight : 24 }}
                        onClick={() => setStep(old => old - 1)}
                    >
                        이전
                    </Button>
                }
                <Button
                    variant="main"
                    fontSize={16}
                    style={{ width : 118}}
                    disabled={getDisabled()}
                    onClick={() => goNext()}
                >
                    {step === 2 ? '발행하기' : '다음'}
                </Button>
            </div>

            <Modal ref={imageModalRef} contentContainer={{ width : 500 }} isHeader title="이미지 등록">
                <CommerceCouponImage addImage={addImage}/>
            </Modal>
        </div>
    )
}

export default CommerceCouponCreate;